/** @format */

import React, { useCallback, useState } from 'react';
import { LinearBillingHistoryList } from '../LinearBillingHistoryList';
import TariffInterface from '../../../interfaces/billing/TariffInterface';
import { LinearBillingInterface } from '../../../interfaces/billing/LinearBillingInterface';
import { LinearBillingEdit } from '../LinearBillingEdit';
import PricelistHistoryInterface, { PricelistHistoryCollectionInterface } from '../../../interfaces/billing/PricelistHistoryInterface';

interface HistoryTabProps {
    tariff: TariffInterface;
    linearBilling: LinearBillingInterface;
    historyList: PricelistHistoryCollectionInterface | undefined;
    updateHistoryList: (historyList: PricelistHistoryCollectionInterface) => void;
}

export const HistoryTab = (props: HistoryTabProps): React.ReactElement => {
    const [openEdit, setOpenEdit] = useState<boolean>(false);
    const [selectedPricelist, setSelectedPricelist] = useState<PricelistHistoryInterface | null>(null);
    const closeDialog = useCallback(() => {
        setOpenEdit(false);
    }, []);

    return (
        <>
            <LinearBillingHistoryList
                tariff={props.tariff}
                linearBilling={props.linearBilling}
                historyList={props.historyList}
                updateHistoryList={props.updateHistoryList}
            />
            {openEdit && <LinearBillingEdit tariff={props.tariff} open={openEdit} selectedPricelist={selectedPricelist} closeDialog={closeDialog} />}
        </>
    );
};
